__turbopack_context__.v({
  "root": "RSQSTG_root",
  "rootIp": "RSQSTG_rootIp",
});
